import * as tsx from 'vue-tsx-support';
import { ChevronDown, ChevronUp, LockIcon, StudentView } from '@codegrade/icons';
import * as buttons from '@/components/Button';
import Collapse from '@/components/Collapse';
import { Icon } from '@/components/Icon';
import { CoursesStore, UserStore } from '@/store';
export default tsx.component({
    name: 'student-exam-footer',
    /** @returns The initial data. */
    data() {
        return {
            hideFooter: false,
        };
    },
    computed: {
        /** @returns The current exam session state. */
        examState() {
            return UserStore.examSession();
        },
        /** @returns The course name for the isolated session. */
        courseName() {
            if (this.examState.tag === 'disabled') {
                return '';
            }
            return CoursesStore.getCourse()(this.examState.courseId).mapOrDefault(c => c.name, 'this course');
        },
        /** @returns The logged in user's name. */
        userName() {
            return UserStore.loggedInUser()
                .chain(u => u.name)
                .orDefault('');
        },
        /** @returns The leave exam button with confirmation modal. */
        leaveExamButton() {
            return (<buttons.PromiseButton class="shrink-0" semantic="critical" prominence={3} confirm={{
                    type: 'modal',
                    body: {
                        type: 'message',
                        message: `You are about to leave the exam for ${this.courseName}. This will end your session and log you out. Are you sure?`,
                    },
                }} action={() => this.handleLeaveExam()} loadingAlertMessage="Leaving exam..." successAlertMessage="You have left the exam">
                    Leave Exam
                </buttons.PromiseButton>);
        },
        /** @returns The content shown when the footer is expanded. */
        contentNode() {
            return (<div class="px-2 py-1 flex items-center gap-2">
                    <Icon class="size-8 mr-1" icon={LockIcon}/>
                    <Icon class="size-8 mr-1" icon={StudentView}/>
                    <div class="grow">
                        <div class="font-bold">
                            Exam session &mdash; Student View &mdash; {this.userName}
                        </div>
                        <div class="text-sm italic">
                            Your session is locked to {this.courseName}. You are viewing this course
                            as a student.
                        </div>
                    </div>
                    {this.leaveExamButton}
                </div>);
        },
    },
    methods: {
        /**
         * Leave the exam by logging out.
         *
         * @returns The promise to leave the exam.
         */
        async handleLeaveExam() {
            return {
                onAfterSuccess: async () => {
                    const redirect = this.$route.fullPath;
                    await UserStore.logout({
                        revoke: true,
                        confirmSessionTermination: true,
                    });
                    this.$router.push({
                        name: 'login',
                        query: { redirect },
                    });
                },
            };
        },
    },
    /** @returns The rendered component. */
    render() {
        return (<div class="session-footer student-exam-footer border rounded-t">
                <button class="mx-2 px-2 py-1 handle inline-block border border-b-0 rounded-t" v-cg-toggle="student-exam-footer-content-collapse" aria-label={`${this.hideFooter ? 'Show' : 'Hide'} the student exam footer`}>
                    <Icon icon={this.hideFooter ? ChevronUp : ChevronDown}/>
                </button>
                <Collapse id="student-exam-footer-content-collapse" v-model={this.hideFooter}>
                    {this.contentNode}
                </Collapse>
            </div>);
    },
});
